import { Radio } from 'antd';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
  updateMandateDates
} from 'api/nach'; type SourceTypeChooseProps = {
  sourceType: string;
  setSourceType: (value: string) => void;
  enach: boolean;
  pnach: boolean;
  autoPay: boolean;
  //setMandateCalculatedStartDate: (date: string | null) => void; // <--- Changed to string | null
};

const StyledRadio = styled(Radio)`
  font-size: 16px;
  font-weight: 400;
  padding: 5px 10px;
  background-color: #2c9897;
  color: white;
`;

function SourceTypeChoose({
  setSourceType,
  sourceType,
  enach,
  pnach,
  autoPay,
  // setMandateCalculatedStartDate,
}: SourceTypeChooseProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const location = useLocation(); // <--- Get the location object
  const queryParams = new URLSearchParams(location.search); // <--- Parse query string

  // Extract mandateId and Token from query parameters
  const mandateIdParam = queryParams.get('mandateId'); // mandateId will be a string or null
  const tokenParam = queryParams.get('Token');       // Token will be a string or null

  // Convert mandateId from string to number, with null/NaN handling
  const mandateId = mandateIdParam ? Number(mandateIdParam) : null;

  // --- Console logs for debugging ---
  console.log('Location object:', location);
  console.log('Query Params:', queryParams.toString());
  console.log('Extracted mandateIdParam (string):', mandateIdParam);
  console.log('Extracted tokenParam (string):', tokenParam);
  console.log('Converted mandateId (number):', mandateId);
  // ------------------------------------
  useEffect(() => {
    console.log('Mandate dates updated  for12378:', sourceType, mandateId);
    const triggerMandateUpdate = async () => {
      console.log('Mandate dates updated  for123:', sourceType, mandateId);
      // Ensure mandateId is a valid number before making the API call
      if ((sourceType === 'E-NACH' || sourceType === 'AutoPay') && mandateId !== null && !isNaN(mandateId)) {
        setLoading(true);
        setError(null);
        //setMandateCalculatedStartDate(null);
        console.log('Mandate dates updated  for23:', sourceType);
        try {
          // Call the API with paymentType and the parsed mandateId
          console.log('Mandate dates updated  for:', sourceType);
          updateMandateDates({ paymentType: sourceType, mandateId: mandateId })
            .then((res) => { console.log('response.data:', res) });
        } catch (err: any) {
          console.error(`Error updating mandate dates for ${sourceType}:`, err);
          const errorMessage = err.response?.data?.error || err.response?.data?.message || err.message || `Failed to update configuration for ${sourceType}.`;
          setError(errorMessage);
          // setMandateCalculatedStartDate(null);
        } finally {
          setLoading(false);
        }
      } else if (mandateId === null || isNaN(mandateId)) {
        // Handle cases where mandateId is not in URL or is not a valid number
        setError('Mandate ID not found in URL or is invalid.');
        //setMandateCalculatedStartDate(null);
        setLoading(false);
      } else {
        // For P-NACH or if no specific type selected, reset states
        //setMandateCalculatedStartDate(null);
        setLoading(false);
        setError(null);
      }
    };

    triggerMandateUpdate();
  }, [sourceType, mandateId]); // Add mandateId to dependency array

  // Optionally, you might want to show a message if mandateId is still null/invalid
  if (mandateId === null || isNaN(mandateId)) {
    return (
      <div style={{ marginLeft: '10px', marginTop: '30px', color: 'red' }}>
        Error: Invalid Mandate ID in URL. Please check the URL.
      </div>
    );
  }
  return (
    <div style={{ marginLeft: '10px', marginTop: '30px' }}>
      <Radio.Group
        defaultValue={sourceType}
        onChange={(e) => setSourceType(e.target.value)}
        size="large"
      >
        {enach ? <StyledRadio value={'E-NACH'}>E-Nach</StyledRadio> : null}
        {pnach ? <StyledRadio value={'P-NACH'}>P-Nach</StyledRadio> : null}

        {autoPay ? <StyledRadio value={'AutoPay'}>Auto Pay</StyledRadio> : null}
      </Radio.Group>
      {loading && <p style={{ marginLeft: '10px', color: 'blue' }}>Updating mandate dates...</p>}
      {error && <p style={{ marginLeft: '10px', color: 'red' }}>{error}</p>}
    </div>
  );
}

export default SourceTypeChoose;
